module.exports = __webpack_public_path__ + "static/media/Louise.dd609bdd.jpg";